<template>
  <div class="proof">
    <section-heading>What is the proof?</section-heading>
    <div class="proof__subtitle">
      <h6>STATISTICS OF LAST 100 PARTICIPANTS</h6>
    </div>
    <div class="background--linear">
      <b-container>
        <div class="proof__stats">
          <div class="proof__statsItem" v-for="(item,index) in statsBox1" :key=index>
            <div class="proof__statsImage">
              <img :src="item.image" alt="" class="ïmg-fluid">
            </div>
            <div class="proof__statsDetails">
              <h6>Reported</h6>
              <h5 class="proof__statsStatus">{{item.text}}</h5>
              <h4 class="proof__statsNumber">{{item.stats}}</h4>	
            </div>
          </div>
        </div>
      </b-container> 
    </div>
    <div class="background--linear">
      <b-container> 
        <div class="proof__stats proof__stats--Box2">
          <div class="proof__statsItem" v-for="(item,index) in statsBox2" :key=index>
            <div class="proof__statsImage">
              <img :src="item.image" alt="" class="ïmg-fluid">
            </div>
            <div class="proof__statsDetails">
              <h6>Reported</h6>
              <h5 class="proof__statsStatus">{{item.text}}</h5>
              <h4 class="proof__statsNumber">{{item.stats}}</h4>	
            </div>
          </div>
        </div>
      </b-container> 
    </div>
    
    <section-button>SEE HOW our Graduates HAVE BENEFITED</section-button>
  </div>
</template>
<script>
import Heading from '../Shared/Heading';
import Button from "../Shared/Button";
import stats1 from '../../assets/image/about/stats-1.png';
import stats2 from '../../assets/image/about/stats-2.png';
import stats3 from '../../assets/image/about/stats-3.png';
import stats4 from '../../assets/image/about/stats-4.png';
export default {
  data(){
    return {
    statsBox1:[
      {
        image:stats1,
        text:'Increase  in Average Business by',
        stats:'200%-300%'
      },
      {
        image:stats2,
        text:'They are now saving on an average',
        stats:'2-3 hrs/day'
      }
    ],
    statsBox2:[
      {
        image:stats3,
        text:'Increase in Work-life balance by',
        stats:'300%-400%'
      },
      {
        image:stats4,
        text:'Increase in Getting things done by',
        stats:'200%-300%'
      }
    ]
  }
},
  components:{
    'section-heading':Heading,
    "section-button": Button,
  }
}
</script>
<style scoped>
.proof { 
  margin-bottom: 50px;
}
.proof__subtitle{
  padding:37px 0;
}

.proof__subtitle h6{
  font-size: 30px;
  line-height: 30px;
  color:var(--primary-color);
  text-transform: uppercase;
  text-align: center;
  font-family: "Seravek-Medium";
  margin-bottom: 0;
}

.proof__stats{
  display: flex;
  justify-content: center;
  align-items: center;
}

.proof__statsItem{
  width:50%;
}

.proof__statsDetails{
  text-align: center;
  color: var(--rare-color);
  font-family: "Seravek-Medium";
  text-transform: uppercase;
  margin:12px 0 47px 0;
  padding-right: 60px;
}

.proof__statsDetails h6{
  font-size: 33px;
  font-family: "Seravek-Light";
  margin-bottom: 0;
}

.proof__statsStatus{
  font-size: 32px;
  margin:27px 0;
}

.proof__statsNumber{
  font-size: 56px;
  color: var(--stats-color);
  margin-bottom: 0;
}

.proof__stats--Box2{
  margin: 115px 0 50px 0;
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .proof__subtitle{
    padding: 25px 0;
  } 

  .proof__subtitle h6{
    font-size: 24px;
    line-height: 28px;
  }

  .proof__stats{
    flex-direction: column;
  }

  .proof__statsItem,.proof__statsImage img{
    width: 100%;
  }

  .proof__statsImage{
    margin: 0 auto;
    width: 100%;
  }

  .proof__statsDetails{
    padding-right: 0;
  }

  .proof__statsDetails h6{
    font-size: 22px;
  }

  .proof__statsStatus{
    font-size: 22px;
    margin: 8px 0;
  }

  .proof__statsNumber{
    font-size: 26px !important
  }

  .proof__stats--Box2{
    margin: 35px 0 25px 0;
  }

  .proof {
    margin-bottom: 35px;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
  .proof__subtitle h6{
    font-size: 22px;
  }
  .proof__subtitle{
    padding: 20px 0;
  }
  .proof__stats{
    flex-direction: column;
  }

  .proof__statsItem,.proof__statsImage img{
    width: 100%;
  }

  .proof__statsImage{
    margin: 0 auto;
    width: 100%;
  }

  .proof__statsDetails{
    padding-right: 0;
  }

  .proof__statsDetails h6{
    font-size: 22px;
  }

  .proof__statsStatus{
    font-size: 22px;
    margin: 8px 0;
  }

  .proof__statsNumber{
    font-size: 26px !important
  }

  .proof__stats--Box2{
    margin: 35px 0 25px 0;
  }

  .proof {
    margin-bottom: 35px;
  }
}
/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  
  .proof__subtitle h6{
    font-size: 24px;
  }
  .proof__subtitle{
    padding: 20px 0;
  }
  .proof__statsImage img{
    margin: 0 auto;
    width: 100%;
  }
  .proof__statsStatus{
    font-size: 28px;
    margin: 15px 0;
  }
  .proof__statsDetails h6{
    font-size: 28px;
  }
  .proof__stats--Box2{
    margin: 40px 0;
  }
}
</style>